import { Button, Loading } from 'components'
import ApproachSection from 'features/College/components/Approach'
import React, { useEffect } from 'react'
import { useUserMutation } from 'services'
import { useLoginState } from 'state'

import { DownloadIcon } from '@radix-ui/react-icons'

import AdmissionProcess from '../../components/AdmissionProcess'
import ApplyNow from '../../components/ApplyNow'
import ApplyNowButton from '../../components/ApplyNowButton'
import CollegeHeroSection from '../../components/CollegeHeroSection'
import CollegeInfo from '../../components/CollegeInfo'
import Companies from '../../components/Companies'
import Curriculum from '../../components/Curriculum'
import Duration from '../../components/Duration'
import Faqs from '../../components/Faqs'
import FeaturesSection from '../../components/Features'
import FeesSection from '../../components/Fees'
import Join from '../../components/Join'
import MentorsSection from '../../components/Mentors'
import OutcomesSection from '../../components/Outcomes'
import TestimonialsSection from '../../components/Testimonials'
import TimeLineSection from '../../components/Timeline'
import Why from '../../components/Why'
// import { BrochureLink } from '../../data/college.data'
import { useCollegeStudent } from '../../services/college.services'

const CollegeLanding = () => {
  const { user, isLoggedIn } = useLoginState()
  const { data: collegeUser } = useCollegeStudent(
    isLoggedIn && user ? user.id.toString() : ''
  )
  const { mutateAsync: userMutation, isLoading: isUserUpdateLoading } =
    useUserMutation()

  useEffect(() => {
    const updateUserToCollegeUser = async () => {
      await userMutation({ is_college_student: true })
    }
    if (user && !user.is_college_student) {
      updateUserToCollegeUser()
    }
  }, [user, userMutation])

  if (isUserUpdateLoading) {
    return <Loading />
  }

  return (
    <div className="flex flex-col gap-y-12 mt-8 md:mt-0">
      <CollegeHeroSection>
        <ApplyNowButton />
        {!(collegeUser && collegeUser.phone_verified) ? (
          // <Link
          //   href={user && isLoggedIn ? '/school/dashboard' : '/school/login'}>
          //   <Button className="bg-white hover:bg-violet-50 text-[#3C3C78] flex items-center gap-x-3">
          //     <DownloadIcon className="w-4 h-4" />
          //     Download Brochure
          //   </Button>
          // </Link>
          <Button
            disabled={true}
            className="bg-white hover:bg-violet-50 text-[#3C3C78] flex items-center gap-x-3">
            <DownloadIcon className="w-4 h-4" />
            Download Brochure
          </Button>
        ) : (
          // <a href={BrochureLink} target={'_blank'} rel="noreferrer">
          //   <Button className="bg-white hover:bg-violet-50 text-[#3C3C78] flex items-center gap-x-3">
          //     <DownloadIcon className="w-4 h-4" />
          //     Download Brochure
          //   </Button>
          // </a>
          <Button
            disabled
            className="bg-white hover:bg-violet-50 text-[#3C3C78] flex items-center gap-x-3">
            <DownloadIcon className="w-4 h-4" />
            Download Brochure
          </Button>
        )}
      </CollegeHeroSection>
      <TimeLineSection />
      <Companies />
      <Why />
      <ApproachSection />
      <FeaturesSection />
      <MentorsSection />
      <Join />
      <Duration />
      <Curriculum />
      <AdmissionProcess />
      <CollegeInfo />
      <OutcomesSection />
      <FeesSection />
      <TestimonialsSection />
      <ApplyNow />
      <Faqs />
    </div>
  )
}

CollegeLanding.layout = {
  screenWidth: true,
  website: 'college'
}

CollegeLanding.seo = {
  title: 'Devsnest School'
}

export default CollegeLanding
